'use client';
import Link from '@ui/components/Link/Link';
import { Button } from '@ngg/components';
import Icon, { IconElements } from '@ui/components/icon/icon';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../../tailwind.config';
import * as styles from './PagePagination.styles';
import useWindowSize from '@utils/useWindowSize';
import config from '@utils/config';

const fullConfig = resolveConfig(tailwindConfig) as any;

type Props = {
  fastNavigationArrowIcon: IconElements;
  fastNavigationArrowLink: string;
  nextNavigationArrowIcon: IconElements;
  nextNavigationArrowLink: string;
  arrowText: string;
  disabled: boolean;
  variants: 'forward' | 'backward';
};
export default function PaginationArrowButtons(props: Props) {
  const {
    disabled,
    fastNavigationArrowIcon,
    fastNavigationArrowLink,
    nextNavigationArrowIcon,
    nextNavigationArrowLink,
    arrowText,
    variants,
  } = props;

  const { isBreakpoint } = useWindowSize('md');
  return (
    <div className={styles.paginationArrowButtons({ layout: variants })}>
      <Button
        as={Link}
        locale={config.locale}
        disabled={disabled}
        href={fastNavigationArrowLink}
        className={styles.arrowButton()}>
        <Icon
          name={fastNavigationArrowIcon}
          size={16}
          color="currentColor"
          // color={disabled ? fullConfig.theme.colors.beige[4] : 'black'}
        />
      </Button>
      <Button
        as={Link}
        locale={config.locale}
        disabled={disabled}
        href={nextNavigationArrowLink}
        className={styles.arrowButton()}>
        <div
          className={styles.paginationIconTextButton({
            layout: variants,
          })}>
          <Icon
            name={nextNavigationArrowIcon}
            size={16}
            color="currentColor"
            // color={disabled ? fullConfig.theme.colors.beige[4] : 'black'}
          />
          {isBreakpoint && arrowText}
        </div>
      </Button>
    </div>
  );
}
